module.exports = __webpack_public_path__ + "img/1544281757.4c00c23e.jpg";